import { alpha, styled, Switch } from '@mui/material';
import { lightGreen } from '@mui/material/colors';


export const GreenSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: lightGreen[500],
    '&:hover': {
      backgroundColor: alpha(lightGreen[500], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: lightGreen[100],
  },
}));
